export var SDKEnvironmentType;
(function (SDKEnvironmentType) {
    SDKEnvironmentType["SANDBOX"] = "sandbox";
    SDKEnvironmentType["PROD"] = "prod";
})(SDKEnvironmentType || (SDKEnvironmentType = {}));
